import ClosableElement from '../closable-element'

class MenuManager {
	constructor() {
		this._init()
	}
	_init() {
		const els = document.querySelectorAll('[data-nav]')
		this.els = [].map.call(els, el => new Menu(el, this))
	}
	onChange(elChanged) {
		this.els.forEach(element => {
			if(element !== elChanged) {
				element.close()
			}
		})
	}
}

class Menu {
	constructor(el, parent) {
		this.el = el
		this.parent = parent
		this._init()
	}
	_init() {
		let elAction = this.el.querySelector('[data-nav-action]')
		elAction.addEventListener("click", (e) => this.onToggle(elAction))
		this.el.closable = new ClosableElement(this.el, () => this.close())
	}
	onResize() {
		if(this.isDesktop()) {
			this.open()
		}
	}
	isDesktop() {
		return window.matchMedia("only screen and (min-width: 1024px)").matches
	}
	onToggle(el) {
		if(!this.isOpen()) {
			this.open()
			this.parent.onChange(this)
		} else {
			this.close()
		}
		el.blur()
	}
	isOpen() {
		return this.el.hasAttribute('open')
	}
	open() {
		this.el.setAttribute('open', '')
	}
	close() {
		this.el.removeAttribute("open")
	}
}

export default MenuManager